import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { Stack, useFocusEffect, useRouter } from 'expo-router';
import { useAuthStore } from '@/store';
import { fetchWithAuth } from '@/lib/api/client';
import Text from '@/components/Typography/Text';
import Button from '@/components/Buttons/Button';
import BotSetupChat from '@/components/Agents/BotSetupChat';
import BotSetupSkeleton from '@/components/Agents/BotSetupSkeleton';
import { NeutralThemeProvider, useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';
export default function CreateBotRoute() {
  return <NeutralThemeProvider><CreateBotContent /></NeutralThemeProvider>;
}
function CreateBotContent() {
  const { theme } = useTheme();
  const router = useRouter();
  const userId = useAuthStore(s => s.user?.id);
  const [session, setSession] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useFocusEffect(useCallback(() => {
    let cancelled = false;
    setSession(null); setError('');
    fetchWithAuth('/json/bot-onboarding', { method: 'POST', body: {}, timeoutMs: 180000, networkRetries: 0 })
      .then(data => { if (!cancelled) setSession(data.session); })
      .catch(err => { if (!cancelled) setError(err.message || 'Could not open bot setup'); });
    return () => { cancelled = true; setSession(null); };
  }, [userId, retry]));
  return <View style={{ flex: 1, backgroundColor: isDarkTheme(theme) ? '#040404' : '#FFFFFF' }}>
    <Stack.Screen options={{ title: 'Create a bot', headerShown: false }} />
    {session ? <BotSetupChat key={session._id} initialSession={session} /> : error ?
      <View style={{ padding: 24, gap: 12 }}><Text accessibilityRole="alert">{error}</Text><Button text="Try again" onPress={() => setRetry(n => n + 1)} /><Button text="Back to bots" onPress={() => router.replace('/agents')} /></View> : <BotSetupSkeleton onBack={() => router.replace('/agents')} />}
  </View>;
}
